import { NotificationGroup } from '@progress/kendo-react-notification';
import { Notification as SnackBarNotification } from '@progress/kendo-react-notification';
import {
  ContentCenteredNotifications,
  ContentCenteredSnackbar,
} from 'app/components/AppNotificationsManager/components';
import { useNotificationsContext } from 'context';
import React from 'react';

export default function AppNotificationsManager() {
  const {
    screenCenteredNotifications,
    contentCenteredNotifications,
    snackbar,
  } = useNotificationsContext();

  return (
    <>
      {!!screenCenteredNotifications.length && (
        <NotificationGroup
          className="alert"
          style={{
            top: '20px',
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 10020,
          }}
        >
          {screenCenteredNotifications?.map(({ notification }) => notification)}
        </NotificationGroup>
      )}

      {!!contentCenteredNotifications.length && (
        <ContentCenteredNotifications
          notifications={contentCenteredNotifications}
        />
      )}

      {snackbar &&
        (snackbar?.position === 'screen-centered' ? (
          <SnackBarNotification className="alert snackbar">
            {snackbar.content}
          </SnackBarNotification>
        ) : (
          <ContentCenteredSnackbar snackbar={snackbar.content} />
        ))}
    </>
  );
}
